import { memoize } from '@codeleap/utils'
import { View, Icon, Text } from '@/components'
import { theme } from '@/config'

export const PoweredBy = memoize(() => {
  return (
    <View style={['fullWidth', 'column', 'mt:auto', 'center', 'gap:0.5', {
      breakpoints: {
        mobile: ['mt:2']
      }
    }]}>
      <View style={['row', 'gap:0.2', 'center']}>
        <Icon name='user-4-line' style={['color:primarySolid500', 'size:1']} />
        <Text
          text='ConnectID'
          style={['semibold', 'c2', { color: theme.baseColors.primarySolid500 }]}
        />
      </View>

      <Text
        text='Powered by Connect'
        style={['medium', 'c2', { color: theme.colors.textCaption }]}
      />
    </View>
  )
})